import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { arrayValidator, dateTimeValidator, enumValidator, stringValidator, uuidValidator, } from '#validation';
import { Component, DaemonEventSource, TelemetryPlatform, } from '#validation/telemetry';
const telemetryRefine = (event, ctx) => {
    if (event.filespaceId ||
        event.userId ||
        event.workspaceId ||
        event.serviceAccountId) {
        if (event.serviceAccountId && event.userId) {
            ctx.addIssue({
                path: [],
                message: 'telemetry.event.ambiguousId',
                code: z.ZodIssueCode.custom,
            });
        }
        return;
    }
    ctx.addIssue({
        path: [],
        message: 'telemetry.event.missingId',
        code: z.ZodIssueCode.custom,
    });
};
const BaseTelemetryEventSchema = z.object({
    eventName: stringValidator({
        requiredError: 'telemetry.event.eventName.required',
    }),
    platform: enumValidator({
        values: TelemetryPlatform,
        requiredError: 'telemetry.event.platform.required',
        invalidValueError: 'telemetry.event.platform.invalid',
    }).optional(),
    platformVersion: stringValidator({
        requiredError: 'telemetry.event.platformVersion.required',
    }).optional(),
    component: enumValidator({
        values: Component,
        requiredError: 'telemetry.event.component.required',
        invalidValueError: 'telemetry.event.component.invalid',
    }),
    componentVersion: stringValidator({
        requiredError: 'telemetry.event.componentVersion.required',
    }),
    clientEventTime: dateTimeValidator({
        requiredError: 'telemetry.event.clientEventTime.required',
    }),
    filespaceId: uuidValidator({
        formatError: 'telemetry.event.filespaceId.invalid',
    }).optional(),
    userId: uuidValidator({
        formatError: 'telemetry.event.userId.invalid',
    }).optional(),
    serviceAccountId: uuidValidator({
        formatError: 'telemetry.event.serviceAccountId.invalid',
    }).optional(),
    workspaceId: uuidValidator({
        formatError: 'telemetry.event.workspaceId.invalid',
    }).optional(),
    nodeId: z.string().optional(),
    customData: z.record(z.string(), z.any()).optional(),
    webBrowser: z.string().optional(),
    daemonEventSource: enumValidator({
        values: DaemonEventSource,
        invalidValueError: 'telemetry.event.daemonEventSource.invalid',
    }).optional(),
});
export const ClientTelemetryEventSchema = BaseTelemetryEventSchema.superRefine(telemetryRefine);
export const ServerTelemetryEventSchema = BaseTelemetryEventSchema.extend({
    id: uuidValidator({
        requiredError: 'telemetry.event.id.required',
        formatError: 'telemetry.event.id.invalid',
    }),
    clientUploadTime: dateTimeValidator({}).optional(),
    serverReceiveTime: dateTimeValidator({
        requiredError: 'telemetry.event.serverReceiveTime.required',
    }),
}).superRefine(telemetryRefine);
export const PublishTelemetrySchema = z.object({
    events: arrayValidator({
        element: ClientTelemetryEventSchema,
        requiredError: 'telemetry.events.required',
    }),
    clientUploadTime: dateTimeValidator({
        requiredError: 'telemetry.clientUploadTime.required',
    }),
});
export class PublishTelemetryDto extends createZodDto(PublishTelemetrySchema) {
}
